import {Component, inject} from '@angular/core';
import {environment} from '../../environments/environment';
import {RouterOutlet} from "@angular/router";
import {AccessService} from "../services/access.service";

@Component({
    selector: 'app-errors',
    imports: [RouterOutlet],
    styles: `
        .bg {
            height: 100%;

            background-position: center;
            background-repeat: no-repeat;
            background-size: cover;
        }
    `,
    template: `
        <div class="bg">
            <div class="container h-100">
                <div class="row h-100 justify-content-center align-items-center">
                    <div class="col-10 col-sm-8 col-md-6 col-lg-4">
                        <div class="card mt-5">
                            <div class="card-body">
                                <div class="d-flex mb-3" style="font-size: 1.2rem">
                                    <div class="flex-shrink-0">
                                        <img [src]="'assets/img/favicon/' + accessService.client.slug + '/android-chrome-192x192.png'" alt="Logo" class="ms-3" style="height: 66px">
                                    </div>
                                    <div class="flex-grow-1 ms-3">
                                        <h5 class="fw-bold mb-0" style="font-size: 30px;">{{ accessService.client.name }}</h5>
                                        <small class="text-muted" style="font-size: 20px">Management Cockpit</small>
                                    </div>
                                </div>
                                <router-outlet/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    `
})
export class ErrorsComponent {

    accessService = inject(AccessService);
    environment = environment;

}
